package com.tovtalk.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.tovtalk.ui.theme.TovTalkSizes
import com.tovtalk.ui.theme.TovTalkTheme

@Composable
fun TovTalkLoadingSpinner(
    modifier: Modifier = Modifier,
    size: Dp = TovTalkSizes.loadingIndicatorMd,
    strokeWidth: Dp = TovTalkSizes.loadingStrokeWidth,
    color: Color = TovTalkTheme.colors.brand,
) {
    CircularProgressIndicator(
        modifier = modifier.size(size),
        color = color,
        strokeWidth = strokeWidth
    )
}

@Composable
fun TovTalkFullScreenLoading(
    modifier: Modifier = Modifier,
    message: String? = null,
) {
    Box(
        modifier = modifier
            .fillMaxSize()
            .background(TovTalkTheme.colors.backgroundPrimary),
        contentAlignment = Alignment.Center
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            TovTalkLoadingSpinner(size = TovTalkTheme.sizes.loadingIndicatorLg)
            if (message != null) {
                Box(Modifier.height(TovTalkTheme.spacing.md))
                Text(
                    text = message,
                    style = TovTalkTheme.typography.bodyMedium,
                    color = TovTalkTheme.colors.textSecondary
                )
            }
        }
    }
}
